$(function() {

  // 服務項目內頁-相關案例輪播
	if ( $('#serviceCasesSlider').length != 0 ) {
    var serviceCasesSlider = new Swiper('#serviceCasesSlider', {
      loop: true,
      pagination: {
        el: ".service-cases-slide-wrap .swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".service-cases-slide-wrap .swiper-button-next",
        prevEl: ".service-cases-slide-wrap .swiper-button-prev",
      },
    });
  }

  // 服務項目內頁-相關文章輪播
	if ( $('#servicePostsSlider').length != 0 ) {
    var servicePostsSlider = new Swiper('#servicePostsSlider', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: ".service-posts-slide-wrap .swiper-button-next",
        prevEl: ".service-posts-slide-wrap .swiper-button-prev",
      },
      breakpoints: {
        1025: { // >= 1025px 時
          slidesPerView: 3,
          spaceBetween: 40,
        },
        641: { // >= 641px 時
          slidesPerView: 2,
          spaceBetween: 20,
        }
      },
    });
  }

});